import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import {
  ENET_ASSET_LIST_NAME_KEY,
  type EnetAssetListColumnId,
  type EnetAssetListKind,
} from './asset-list-columns';

export function useEnetAssetListColumnLabels() {
  const tCards = useTranslations('designSystem.applicationAssets.cards');
  const tAssets = useTranslations('designSystem.applicationAssets');
  const tDetail = useTranslations('externalNetwork.assetDetail');
  const tKinds = useTranslations('externalNetwork.entityKinds');
  const tList = useTranslations('externalNetwork.assetList');
  const tFilters = useTranslations('externalNetwork.assetFilters');

  const nameColumnLabel = useCallback(
    (listKind: EnetAssetListKind): string =>
      listKind === 'ALL'
        ? tCards('asset')
        : tKinds(ENET_ASSET_LIST_NAME_KEY[listKind]),
    [tCards, tKinds],
  );

  const columnLabel = useCallback(
    (column: EnetAssetListColumnId): string => {
      switch (column) {
        case 'findings':
          return tCards('findings');
        case 'signals':
          return tCards('signals', { count: 2 });
        case 'assetType':
          return tAssets('type');
        case 'attribution':
          return tList('columns.attribution');
        case 'scope':
          return tDetail('scope');
        case 'source':
          return tDetail('source');
        case 'ip':
          return tList('columns.ip');
        case 'registrant':
          return tList('columns.registrant');
        case 'country':
          return tList('columns.country');
        case 'hosts':
          return tKinds('host');
        case 'level':
          return tList('columns.level');
        case 'subdomains':
          return tList('columns.subdomains');
        case 'dnsRecords':
          return tDetail('dnsRecords');
        case 'resolvesTo':
          return tList('columns.resolvesTo');
        case 'registrar':
          return tList('columns.registrar');
        case 'reverseDns':
          return tList('columns.reverseDns');
        case 'netblock':
          return tKinds('netblock');
        case 'provider':
          return tDetail('provider');
        case 'function':
          return tList('columns.function');
        case 'domains':
          return tKinds('domain');
        case 'services':
          return tKinds('service');
        case 'transport':
          return tFilters('transportProtocol');
        case 'host':
          return tDetail('host');
        case 'tls':
          return tDetail('tls');
        case 'vendor':
          return tDetail('vendor');
        case 'domain':
          return tDetail('domain');
        case 'category':
          return tDetail('category');
        case 'detection':
          return tList('columns.detection');
        case 'access':
          return tList('columns.access');
      }
    },
    [tAssets, tCards, tDetail, tFilters, tKinds, tList],
  );

  return { nameColumnLabel, columnLabel };
}
